import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function IubireFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Este cursul doar pentru persoane singure?',
    a: 'Nu. Este pentru oricine vrea să îmbunătățească relația cu sine și cu ceilalți. Fie că ești într-o relație, fie că ești singur/ă, iubirea de sine e fundația pe care se construiește totul.'
  }, {
    q: 'Dacă am răni emoționale profunde, mă ajută?',
    a: 'Da. Cursul include exerciții specifice de eliberare a resentimentelor, practici de iertare și meditații de vindecare emoțională. Este gândit exact pentru persoane care poartă durere neprocesată.'
  }, {
    q: 'Este necesar să cred în spiritualitate?',
    a: 'Nu e necesar, dar ajută să fii deschis/ă la ideea de conexiune interioară. Exercițiile practice funcționează indiferent de credințele tale. Meditațiile ghidate sunt accesibile și pentru persoane care nu au experiență anterioară.'
  }, {
    q: 'Ce este exercițiul oglinzii?',
    a: 'O tehnică prin care stai în fața oglinzii, te privești în ochi și îți spui lucruri pe care poate nu le-ai auzit niciodată de la nimeni. E simplu ca formă, dar profund ca efect. Mulți participanți spun că e momentul în care s-au simțit iubiți pentru prima dată cu adevărat.'
  }, {
    q: 'În cât timp simt schimbări?',
    a: 'Mulți participanți simt eliberare și liniște încă din timpul cursului. Schimbările mai profunde în relații și în felul cum te raportezi la tine vin pe măsură ce practici zilnic exercițiile și afirmațiile.'
  }, {
    q: 'Pot cumpăra doar acest curs fără tot pachetul Academiei?',
    a: 'Da. Cursul se poate achiziționa separat la 500 lei cu acces pe viață. Dacă vrei toate cele 6 cursuri plus întâlniri de grup, Programul Standard complet costă 1.985 lei integral și economisești față de cumpărarea separată.'
  }, {
    q: 'Pot face exercițiile dacă îmi este greu să mă deschid emoțional?',
    a: 'Da. Cursul te ghidează treptat, pas cu pas. Nu te forțează nimeni să te deschizi mai mult decât ești pregătită. Adrian creează un spațiu sigur și cald în care procesul vine natural, în ritmul tău.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1449">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1450">
        <SectionHeading title="Întrebări Frecvente" data-id="element-1451" />

        <div className="space-y-4 mb-16" data-id="element-1452">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-brand-text/10 rounded-2xl overflow-hidden bg-brand-cream/50" data-id="element-1453">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-1454">
                <span className="font-bold text-lg text-brand-text pr-8" data-id="element-1455">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-1456" />
              </button>
              <AnimatePresence data-id="element-1457">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-1458">
                    <div className="px-6 pb-5 text-brand-textSec leading-relaxed" data-id="element-1459">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1460">
          <CTAButton data-id="element-1461" />
        </motion.div>
      </div>
    </section>;
}